import React from "react";
import axios from "axios";

import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Smile from "../images/smile.gif";

// images
import Logo from "../images/25.png";

import {
  GiftOutlined,
  UserOutlined,
  FrownOutlined,
  MehOutlined,
  SmileOutlined,
} from "@ant-design/icons";

// components
import "antd/dist/antd.css";
import {
  Button,
  Row,
  Col,
  Affix,
  Divider,
  Rate,
  Drawer,
  Input,
  message,
  Typography,
  Space,
} from "antd";

import { HomeOutlined } from "@ant-design/icons";

import { db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

const { TextArea } = Input;
const { Title, Paragraph } = Typography;

function Notify() {
  // ตรวจสอบว่าใน Cart มีแพ็คเกจ 26Pro01 หรือไม่ (ใช้สำหรับแสดงเนื้อหา We Are Back Stronger)
  const [showWeAreBack, setShowWeAreBack] = useState(false);

  const checkWeAreBack = () => {
    try {
      const c = JSON.parse(localStorage.getItem("Cart") || "[]");
      if (Array.isArray(c) && c.find((x) => x.ecoupon_code === "26Pro002")) {
        setShowWeAreBack(true);
      } else {
        setShowWeAreBack(false);
      }
    } catch (e) {
      setShowWeAreBack(false);
    }
    localStorage.removeItem("Cart");
  };

  useEffect(() => {
    checkOrderNo();
    checkWeAreBack();

    // อัปเดตเมื่อ localStorage ถูกเปลี่ยนจากแท็บอื่น
    const onStorage = (e) => {
      if (e.key === "Cart") {
        checkWeAreBack();
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const [visible, setVisible] = useState(false);
  const [rate, setRate] = useState(0);
  const [comment, setComment] = useState("");

  const key = "updatable";

  const checkOrderNo = () => {
    if (localStorage.getItem("OrderNo") !== null) {
      setVisible(true);
    }
  };

  const handleOk = async () => {
    message.loading({
      content: "กำลังประเมิน...",
      key,
    });

    let obj = {};
    obj.orderNo = localStorage.getItem("OrderNo");
    obj.rate = rate;

    if (comment !== "") {
      obj.comment = comment.target.value;
    } else {
      obj.comment = "";
    }

    const querySnapshot = await getDocs(
      query(collection(db, "googlesheet"), where("isactive", "==", true)),
    );

    const idGoogleSheet = querySnapshot.docs.map((doc) => doc.data());

    obj.idGoogleSheet = idGoogleSheet[0].id;

    var config = {
      method: "POST",
      url: "https://us-central1-bhh-healthexpo.cloudfunctions.net/app/api/insert/csi",
      // url: "http://localhost:5001/bhh-healthexpo/us-central1/app/api/insert/csi",

      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Origin": "*",
      },
      data: obj,
    };

    try {
      let res = await axios(config);

      // console.log(res)

      message.success({
        content: "ประเมินสำเร็จ!",
        key,
      });
    } catch (e) {
      console.log(e);
    }

    setVisible(false);
    localStorage.removeItem("OrderNo");
    setRate(0);
  };

  const onClose = () => {
    setVisible(false);
  };

  const customIcons = {
    1: <FrownOutlined />,
    2: <FrownOutlined />,
    3: <MehOutlined />,
    4: <SmileOutlined />,
    5: <SmileOutlined />,
  };

  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col span={21} style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        Bangkok Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "32px 16px",
        }}
      >
        <div
          style={{
            maxWidth: 620,
            width: "100%",
            background: "#ffffff",
            borderRadius: 12,
            padding: 24,
            // boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
            textAlign: "center",
          }}
        >
          <img src={Smile} alt="" width={96} style={{ marginBottom: 12 }} />

          <Title level={4} style={{ marginBottom: 8 }}>
            ขอบคุณสำหรับการสั่งซื้อ
          </Title>

          <Paragraph style={{ marginBottom: 6 }}>
            ท่านจะได้รับ SMS สำหรับชำระเงิน <br />
            และได้รับ E-Coupon ผ่านช่องทาง E-mail
          </Paragraph>
          <br />
          <Divider style={{ margin: "8px 0 16px" }} />
          <br />
          <Title level={4} style={{ marginBottom: 8, color: "#b21e2a" }}>
            ประเมินความเสี่ยง<br/>โรคหัวใจและหลอดเลือด
          </Title>

          <Paragraph style={{ marginBottom: 6 }}>
            ใช้เวลาเพียง 2 นาที<br/>เพื่อวางแผนการดูแลสุขภาพที่ดีที่สุดสำหรับคุณ
          </Paragraph>

          <Button
            type="primary"
            shape="round"
            size="middle"
            href="https://thai-cv-risk.vercel.app/?company=Shopping%20World"
            target="_blank"
            rel="noreferrer"
            style={{
              background: "#1e366f",
              borderColor: "#1e366f",
              color: "#ffffff",
              fontWeight: "bold",
              marginTop: 12,
            }}
          >
            เริ่มทำแบบประเมิน &gt;
          </Button>

          {showWeAreBack !== true ? null : (
            <>
              <br />
              <Title level={5} style={{ marginBottom: 8, color: "#b21e2a" }}>
                สำหรับลูกค้าที่ซื้อโปรแกรม
                <br />
                "We Are Back Stronger"
              </Title>
              <Paragraph style={{ marginBottom: 6 }}>
                {/* เพื่อให้การดูแลของท่านเป็นไปอย่างเหมาะสม
            <br /> */}
                กรุณาทำแบบประเมินสุขภาพใจเบื้องต้น
                <br />
                และรอเจ้าหน้าที่ติดต่อกลับ เพื่อทำการนัดหมาย
                <br />
                การปรึกษาแพทย์ผ่านระบบ Teleconsultation
              </Paragraph>
              <br />
              <Button
                type="primary"
                shape="round"
                size="middle"
                href="https://bhh-assessment.web.app/assessment/mental"
                target="_blank"
                rel="noreferrer"
                style={{ background: "#1e366f", borderColor: "#1e366f" }}
              >
                ทำแบบประเมินสุขภาพใจ
              </Button>
            </>
          )}

          {/* <NavLink to="/">
              <Button
                shape="round"
                ghost
                type="primary"
                htmlType="submit"
                style={{
                  color: "#b21e2a",
                  borderColor: "#b21e2a",
                  marginTop: 12,
                }}
              >
                หน้าแรก <HomeOutlined />
              </Button>
            </NavLink> */}
        </div>
      </div>

      <Drawer
        title="ประเมินความพึงพอใจ"
        placement="bottom"
        onClose={onClose}
        visible={visible}
        height={280}
        extra={
          // <Space>
          <Button
            type="primary"
            ghost
            onClick={handleOk}
            disabled={rate !== 0 ? false : true}
            shape="round"
            size="small"
          >
            ยืนยัน
          </Button>
          // </Space>
        }
      >
        <div style={{ textAlign: "center" }}>
          น้อยที่สุด
          <Rate
            character={({ index }) => customIcons[index + 1]}
            onChange={setRate}
            style={{
              fontSize: "20px",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          />
          มากที่สุด
          <br />
          <br />
          <TextArea
            rows={4}
            placeholder="ข้อเสนอแนะเพิ่มเติม"
            onChange={setComment}
          />
        </div>
      </Drawer>
    </div>
  );
}

export default Notify;

